export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9590.3a971c24.jpg";